'use client';

import { c as _c } from "react/compiler-runtime";
import { useConfig } from '@/hooks/use-config';
import { useProjectsContext } from '@/providers/projects-provider';
import { StableTimestamp } from '@/providers/stable-timestamp.provider';
import { getEffectiveNow } from '@/utils/effective-now';
import { useMemo } from 'react';
export type NebulyPageEffectiveNow = {
  effectiveNow: Date;
  /** False while project configuration is loading — defer pin-dependent queries until ready. */
  isReady: boolean;
};

/** Pinned analysed end date as effective "today" for custom Nebuly page time ranges. */
export function useNebulyPageEffectiveNow() {
  const $ = _c(6);
  const {
    getTimestamp
  } = StableTimestamp.useProvided();
  const {
    projectId,
    selectedProject
  } = useProjectsContext();
  const originalProjectId = selectedProject?.mappedProjectId ?? projectId;
  const {
    data: config,
    isLoadingData
  } = useConfig(originalProjectId);
  const stableNowKey = getTimestamp().getTime();
  config?.analysed_data_end_date;
  const t0 = config?.analysed_data_end_date;
  let t1;
  if ($[0] !== getTimestamp || $[1] !== t0) {
    t1 = getEffectiveNow(t0, getTimestamp());
    $[0] = getTimestamp;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const effectiveNow = t1;
  const t2 = !isLoadingData;
  let t3;
  if ($[3] !== effectiveNow || $[4] !== t2) {
    t3 = {
      effectiveNow,
      isReady: t2
    };
    $[3] = effectiveNow;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}